import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/pages.services";
import * as subAdmin from "../../../services/subAdmin.service";
import { SWAL_SETTINGS, MENU_LOCATION, showFilterList, INPUT_LENGTH_50, USER_GENDER } from "../../../../../utils/Constants";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { PhoneInput } from "react-universal-phone";
const SubAdminEdit = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { state } = useLocation();
    const { t } = useTranslation()
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [userRoles, setuserRoles] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showdefault, setShowDefault] = useState({});
    

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Sub admin"), url: "/admin/user-management/sub-admins/list/1" },
        { title: t("btn_edit"), url: "" },
    ];

    useEffect(() => {
        subAdmin
            .Details(params.id)
            .then((data) => {
                setShowDefault(data && data?.data ? data.data : []);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);


    const getPhoneValue = (phone) => {
        if (!phone || !phone.includes(" ")) {
            return {
                number: "",
                dialCode: "44",
            };
        }

        const [dialCode, number] = phone.split(" ");
        return { dialCode, number };
    };
    useEffect(() => {
        subAdmin.Roles().then(res => {
            if (res.success) {
                setuserRoles(res.data);
            }
        });
    }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <Formik
                    initialValues={{
                        firstName: showdefault && showdefault.firstName ? showdefault.firstName : "",
                        lastName: showdefault && showdefault.lastName ? showdefault.lastName : "",
                        email: showdefault && showdefault.email ? showdefault.email : "",
                        password: "",
                        confirmPassword: "",
                        // phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
                        // gender: showdefault && showdefault.gender ? showdefault.gender : "",
                        permissionRole:showdefault && showdefault.permissionRole && showdefault.permissionRole.id ? showdefault.permissionRole.id: "",
                        role: showdefault && showdefault.role ? showdefault.role : "",
                        status: showdefault && showdefault.status ? showdefault.status : "",
                    }}
                    validateOnBlur={false}
                    validate={(values) => {
                        const error = {};
                        const firstName = values.firstName?.trim() || "";
                        const lastName = values.lastName?.trim() || "";
                        const email = values.email?.trim() || "";
                        const password = values.password?.trim() || "";
                        const confirmPassword = values.confirmPassword?.trim() || "";
                        // const phone_number = values.phone_number?.trim() || "";
                        // const gender = values.gender || "";
                        const permissionRole = values.permissionRole || "";
                        const status = values.status || "";

                        // First Name Validation
                        if (firstName && firstName.length > INPUT_LENGTH_50)
                            error.firstName = t("validation_err_reached_maximum_length");

                        // Last Name Validation
                        if (lastName && lastName.length > INPUT_LENGTH_50)
                            error.lastName = t("validation_err_reached_maximum_length");

                        // Email Validation
                        if (!email) error.email = t("label_email_error");
                        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email))
                            error.email = t("validation_err_invalid_email");

                        // Phone Number Validation
                        // if (!phone_number) error.phone_number = t("label_phone_number_error");

                        // Gender Validation
                        // if (!gender) error.gender = t("label_gender_error");

                        // Permission Role Validation
                        if (!permissionRole) error.permissionRole = t("label_permissionRole_error");

                        // Status Validation
                        if (!status) error.status = t("validation_err_status_required");

                        return error;
                    }}

                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitted(true);
                        globalLoader(true);
                        console.log(values);
                        const id = params.id;
                        let formData = new FormData();
                        formData.append("firstName", values.firstName);
                        formData.append("lastName", values.lastName);
                        formData.append("email", values.email);
                        formData.append("password", values.password);
                        formData.append("confirmPassword", values.confirmPassword);
                        // formData.append("phone_number", values.phone_number);
                        // formData.append("gender", values.gender);
                        formData.append("role", values.role);
                        formData.append("permissionRole", values.permissionRole);
                        formData.append("status", values.status);
                        subAdmin
                            .Edit(formData,id)
                            .then((response) => {
                                setSubmitting(false);
                                if (response.success) {
                                    Swal.fire({
                                        icon: "success",
                                        text: response.message,
                                        ...SWAL_SETTINGS,
                                    });
                                    setTimeout(() => {
                                        resetForm({ values: "" });
                                        globalLoader(false);
                                        navigate(`/admin/user-management/sub-admins/list/1`);
                                    }, 1000);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        text: handleServerValidations(response),
                                        ...SWAL_SETTINGS,
                                    });
                                    setSubmitted(false);
                                    globalLoader(false);
                                }
                            })
                            .catch((error) => {
                                console.log("error ====> ", error);
                            });
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        setFieldTouched,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="row row-sm">
                                <div className="col-lg-12 col-md-12 animation_fade">
                                    <div className="card custom-card">
                                        <div className="card-body">
                                            <div>
                                                <h6 className="main-content-label mb-3">Sub Admin edit</h6>
                                            </div>
                                            <div className="row row-sm">
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="firstName" className="text-left d-flex">
                                                        {t("label_page_firstName")}:
                                                    </label>
                                                    <input
                                                        name="firstName"
                                                        id="firstName"
                                                        type="text"
                                                        placeholder="Enter the first name"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.firstName}
                                                        className="form-control"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.firstName && touched.firstName && errors.firstName}
                                                    </span>
                                                </div>



                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="lastName" className="text-left d-flex">
                                                        {t("label_lastName")}:
                                                    </label>
                                                    <input
                                                        name="lastName"
                                                        id="lastName"
                                                        type="text"
                                                        placeholder="Enter the last name"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.lastName}
                                                        className="form-control"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.lastName && touched.lastName && errors.lastName}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="email" className="text-left d-flex">
                                                        {t("label_email")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="email"
                                                        id="email"
                                                        type="text"
                                                        placeholder="Enter the email"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.email}
                                                        className="form-control"
                                                        disabled={true}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.email && touched.email && errors.email}
                                                    </span>
                                                </div>

                                                <div className="col-md-6 text-center form-group">
                                                    <label htmlFor="status" className="text-left d-flex">
                                                        {t("list_heading_status")}:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <div className=" select-down-arrow">
                                                        <select
                                                            name="status"
                                                            id="status"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.status}
                                                            className="form-control" >

                                                            {(showFilterList).map((value, i) => {
                                                                return (
                                                                    <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.status &&
                                                            touched.status &&
                                                            errors.status}
                                                    </span>
                                                </div>

                                                {/* <div className="col-md-6 text-center form-group">
                                                    <label htmlFor="gender" className="text-left d-flex">
                                                        {t("label_gender")}:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <div className=" select-down-arrow">
                                                        <select
                                                            name="gender"
                                                            id="gender"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.gender}
                                                            className="form-control" >

                                                            <option value="">{t("input_select_text")}</option>
                                                            {Object.keys(USER_GENDER).map((key, i) => {
                                                                return (
                                                                    <option key={i} value={USER_GENDER[key]}>{t(`${key}`)}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.gender &&
                                                            touched.gender &&
                                                            errors.gender}
                                                    </span>
                                                </div> */}
                                                <div className="col-md-6 text-center form-group">
                                                    <label htmlFor="permissionRole" className="text-left d-flex">
                                                        {t("list_heading_permissionRole")}:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <div className=" select-down-arrow">
                                                        <select
                                                            name="permissionRole"
                                                            id="permissionRole"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.permissionRole}
                                                            className="form-control" >

                                                            <option value="">{t("input_select_text")}</option>

                                                            {userRoles.length > 0 &&
                                                                userRoles.map((role) => (
                                                                    <option key={role.id} value={role.id}>
                                                                        {role.title}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.permissionRole &&
                                                            touched.permissionRole &&
                                                            errors.permissionRole}
                                                    </span>
                                                </div>
                                                {/* <div className="col-md-6 phone-input-wrapper">
                                                    <label className="text-left d-flex" htmlFor="phone_number">
                                                        {t("label_phone_number")}
                                                        <span className="requirestar">*</span>
                                                    </label>

                                                    <PhoneInput defaultCountry="GB" locale="en"
                                                        value={getPhoneValue(values.phone_number)}
                                                        label={false}
                                                        onBlur={() => setFieldTouched("phone_number", true)}
                                                        onChange={(data) => {
                                                            setFieldValue(
                                                                "phone_number",
                                                                data?.formattedPhoneNumber
                                                            );
                                                        }}
                                                        id="phone_number" />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.phone_number &&
                                                            touched.phone_number &&
                                                            errors.phone_number}
                                                    </span>
                                                </div> */}
                                                {/* Password */}
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="password" className="text-left d-flex">
                                                        {t("label_password")}:
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            name="password"
                                                            id="password"
                                                            className="form-control"
                                                            placeholder={t("placeholder_new_password")}
                                                            value={values.password}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span
                                                            className="input-group-text cp"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        >
                                                            {showPassword ? (
                                                                <i className="far fa-eye"></i>
                                                            ) : (
                                                                <i className="far fa-eye-slash"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.password && touched.password && errors.password}
                                                    </span>
                                                </div>

                                                {/* Confirm Password */}
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="confirmPassword" className="text-left d-flex">
                                                        {t("label_confirm_password")}:
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            type={showConfirm ? "text" : "password"}
                                                            name="confirmPassword"
                                                            id="confirmPassword"
                                                            className="form-control"
                                                            placeholder={t("placeholder_confirm_password")}
                                                            value={values.confirmPassword}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            autoComplete="off"
                                                        />
                                                        <span
                                                            className="input-group-text cp"
                                                            onClick={() => setShowConfirm(!showConfirm)}
                                                        >
                                                            {showConfirm ? (
                                                                <i className="far fa-eye"></i>
                                                            ) : (
                                                                <i className="far fa-eye-slash"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}
                                                    </span>
                                                </div>
                                                <div className="">
                                                    <button
                                                        className="btn btn-main-primary signbtn mr-2"
                                                        type="submit"
                                                        disabled={submitted ? true : null}
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("btn_submit")}
                                                    </button>
                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        type="button"
                                                        disabled={submitted ? true : null}
                                                        onClick={() => navigate(-1)}
                                                    >
                                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                        {t("btn_cancel")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <></>
            )}
        </>
    );
};

export default SubAdminEdit;
